import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { bdsGridModeType } from '@bds/components';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-bad-order-history',
    templateUrl: './bad-order-history.component.html',
    styleUrl: './bad-order-history.component.css',
})
export class BadOrderHistoryComponent implements OnInit {
    public gridId = 135;
    public gridMode: bdsGridModeType = 'single';
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Bad Order History Report';
    public gridSource: any;
    public selectedRowKeys: Array<number> = [];
    public displayReport: boolean = false;
    public controlNames: string[] = ['Bad Order Start Date', 'Bad Order End Date'];

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit() {
        this.pageService.setHeader(this.pageHeader);
    }

    customizeColumns = (columns: any[]) => {
        const datePipe = new DatePipe('en-US');
        const shipCol = columns.find((c: any) => c.dataField === 'ship_date_time');
        if (shipCol) {
            shipCol.dataType = 'date';
            shipCol.calculateDisplayValue = (rowData: any) => {
                const value = rowData['ship_date_time'];
                return value ? datePipe.transform(value, 'MM/dd/yyyy', 'UTC') : '';
            };
        }
        ['bad_order_start', 'bad_order_end'].forEach((field) => {
            const col = columns.find((c: any) => c.dataField === field);
            if (col) {
                col.dataType = 'datetime';
                col.calculateDisplayValue = (rowData: any) => {
                    const value = rowData[field];
                    return value ? datePipe.transform(value, 'MM/dd/yyyy HH:mm', 'UTC') : '';
                };
            }
        });
    };

    onGetReportClick(event: any) {
        this.displayReport = true;
        this.gridSource = this.reportService.CreateAspNetDatastore(
            ReportConstants.ReportDataApiCall,
            this.gridId.toString(),
            event.startDate,
            event.endDate,
        );
    }

    onCancelClick() {
        this.displayReport = false;
    }
}
